// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // endPointStage : 'https://apistage.phlenu.com/api/',
  // endPointProd : 'https://api5.phlenu.com/api/',
  serviceWorker: true,
  firebaseConfig: {
    apiKey: 'AIzaSyAI90Pe3JE7sjWwUn9ab77csttpJskEorE',
    authDomain: 'phlenu-delivery.firebaseapp.com',
    databaseURL: 'https://phlenu-delivery.firebaseio.com',
    projectId: 'phlenu-delivery',
    storageBucket: 'phlenu-delivery.appspot.com',
    messagingSenderId: '325976906645',
    appId: '1:325976906645:web:3d8eb09f6cf40577d8b49c',
    measurementId: 'G-FC0CZF3TNF',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
